import { Trophy, Target, BarChart2, Users } from 'lucide-react';

const heroSection = {
  subText: "Trusted Outsourcing & Financial Services Partner",
  title: "Outsourcing Services That Reduce Cost and Increase Output ",
  description: "We support investment firms, advisory teams, and growing businesses with expert accounting, research, analytics, and business support that reduces execution burden.",
  button: "Explore Our Services",
  buttonUrl: "#services",
  button2: "Contact Our Team",
  button2Url: "/contact",
  image: "/images/home-hero-9.png",
};

const services = {
  subtext: "Our Services",
  title: "Comprehensive Consulting for Every",
  highlightTitle: "Financial Need",
  description: "From strategic planning to sustainable growth, our tailored services help businesses and institutional clients achieve operational clarity, financial control, and long-term success.",
  service: [
    {
      title: "Accounting & Bookkeeping Services",
      description:
        " End-to-end accounting, bookkeeping, and compliance support designed to keep financials accurate, audit-ready, and decision-driven. ",
      image: "/images/home-accounting.png",
      link: "/services/accounting-and-bookkeeping",
    },
    {
      title: "Capital Market Research",
      description:
        "Quantitative and qualitative market intelligence, equity research, and financial modeling to support investment decisions, valuations, and strategic capital allocation.",
      image: "/images/home-capital-market.png",
      link: "/services/capital-market-research",
    },
    {
      title: "Investment & Transaction Advisory",
      description:
        "End-to-end investment and transaction advisory support across mergers, acquisitions, fundraising, and strategic transactions, backed by rigorous financial analysis, valuation modeling, and deal execution assistance.",
      image: "/images/home-investment-advisory.png",
      link: "/services/investment-transaction-advisory",
    },
    {
      title: "Market Research",
      description:
        "Deep research and competitive analysis to guide market entry, growth strategy, and operational decision-making with structured insights and industry benchmarks.",
      image: "/images/home-market-research.png",
      link: "/services/market-research",
    },
    {
      title: " Data Analytics & Business Intelligence",
      description:
        "Advanced analytics, dashboards, and data frameworks that transform raw data into operational intelligence to reduce risk, optimize performance, and enable growth.",
      image: "/images/home-data-analytics.png",
      link: "/services/data-analytics",
    },
    {
      title: "Business Support & Process Outsourcing",
      description:
        "Business support solutions including back-office processes, data processing, executive assistance, and administration tailored to improve efficiency and reduce overhead.",
      image: "/images/home-business-process.png",
      link: "/services/business-development",
    },
  ]
};

const aboutUs = {
  subtext: "About Us",
  title: "Transforming Operations into Measurable Performance ",
  description: "From financial accuracy to strategic growth, our tailored solutions help businesses and investors operate efficiently, reduce costs, and scale with confidence. ",
  heading: "Your Strategic Finance & Research Partner",
  subHeading: "At Seternity Solutions, we combine domain expertise with structured processes and technology-enabled workflows to deliver accounting, capital markets research, market intelligence, business development, and analytics support across industries.",
  subHeading2: "We operate as an extension of your team, improving output while reducing management overhead.",
  features: [
    "Cost-efficient delivery without compromising quality",
    "Structured, repeatable workflows for consistent output",
    "Faster turnaround across finance and research functions",
    "Scalable support aligned to deal flow and business growth",
    "Confidential, disciplined, and institution-ready deliverables"
  ],
  button: "Learn more about us",
  buttonLink: "/about-us"
}

const whyChoose = {
  subtext: "Why Us",
  title: "Strategic Financial Insight, Delivered with Precision",
  description: "We go beyond traditional outsourcing by combining deep financial expertise, structured execution, and scalable delivery to support critical business decisions. ",
  button: "Contact Us",
  buttonLink: "/contact",
  image: "/images/home-why-us.png",
  features: [
    {
      icon: <Trophy className="w-6 h-6 text-[#4F7AC2]" />,
      title: "Unmatched Domain Expertise",
      description: "Our teams bring deep experience across finance, accounting, capital markets, and analytics—delivering work that meets institutional standards and decision-critical requirements."
    },
    {
      icon: <BarChart2 className="w-6 h-6 text-[#4F7AC2]" />,
      title: "Scalable & Flexible Engagement Models",
      description: "We offer flexible engagement structures that scale with your needs, enabling efficient execution across projects, deal cycles, and ongoing operational requirements."
    },
    {
      icon: <Users className="w-6 h-6 text-[#4F7AC2]" />,
      title: "Seamless Team Integration",
      description: "We operate as a natural extension of your internal teams, ensuring continuity, confidentiality, and alignment with your workflows and reporting standards."
    },
    {
      icon: <Target className="w-6 h-6 text-[#4F7AC2]" />,
      title: "Cost Efficiency Without Compromise",
      description: "Our delivery model enables significant cost savings while maintaining accuracy, turnaround time, and quality expected from experienced finance and research professionals."
    }
  ],
  stats: [
    // { label: "Clients Managed", value: "100+" },
    { label: "Research Projects Delivered", value: "500+" },
    { label: "Sectors Covered", value: "40+" },
    { label: "Years Experience", value: "10+" },
    { label: "Client Satisfaction", value: "90%" }
  ],
}

const testimonials = [
  {
    review:
      "Their FP&A support brought much-needed discipline and transparency to our financial planning process. Budgeting, forecasting, and variance analysis became more structured and decision-focused, giving our leadership team clearer visibility into performance drivers. They quickly understood the nuances of healthcare operations and translated data into practical guidance. The engagement elevated our internal finance capabilities in a meaningful way.",
    position: " CFO",
    company: "Oregon Based Healthcare Organization",
    service: "FP&A support services",
    rating: 5,
  },
  {
    review:
      "The market research delivered was sharp, data-backed, and directly relevant to our acquisition strategy. Instead of broad overviews, we received targeted insights on submarket dynamics, tenant demand trends, and risk factors that actually influence underwriting decisions. The analysis helped us refine our investment thesis and move forward with greater conviction. Clear thinking, strong analytics, and results that translated into action",
    position: " CEO",
    company: "California based REIT Corporation",
    service: "Market Research",
    rating: 5,
  },
  {
    review:
      "The research engagement gave us depth where we needed it most. The team understood how bankers think and structured the analysis accordingly, concise, commercially relevant, and aligned with live deal timelines. Their sector insights and valuation work strengthened our pitch materials and internal positioning. It was thoughtful, high-caliber support that integrated smoothly into our workflow",
    position: "Co-Founder",
    company: "Houston Based Investment Bank",
    service: "Investment Banking Research",
    rating: 5,
  },
  {
    review:
      "What stood out was the intellectual rigor behind the analysis. The research was not just informative, it was discerning. Key value drivers were clearly isolated, downside risks were thoughtfully framed, and conclusions were grounded in evidence rather than broad commentary. That level of preparation improves investment committee discussions and ultimately leads to better capital allocation decisions",
    position: "Managing Partner ",
    company: "Massachusetts based Private Equity Firm",
    service: "Private Equity Research",
    rating: 5,
  },
  {
    review:
      "The modeling support was practical and execution-focused. They built clean, flexible models that were easy to audit, update, and present internally. Beyond the numbers, they supported portfolio reporting and performance tracking in a way that reduced our internal workload. The work was efficient, accurate, and aligned with how we manage assets post-close",
    position: "Associate",
    company: "Texas Based Private Equity Firm",
    service: "Financial Modelling and Portfolio Support Services",
    rating: 5,
  },
]

const faqs = [
  {
    question: "What makes your approach different from other agencies?",
    answer:
      "We don’t sell buzzwords or pretty decks. Our work is built on process discipline, technical depth, and decisions that scale under real-world pressure.",
  },
  {
    question: "How involved do clients need to be during the project?",
    answer:
      "Involved enough to make decisions, not micromanage. We run a tight process and only pull you in when your input actually matters.",
  },
  {
    question: "Do you work with early-stage startups or only established companies?",
    answer:
      "Both. Early-stage teams get structure and clarity. Established companies get systems that don’t fall apart at scale.",
  },
  {
    question: "How do you handle feedback and revisions?",
    answer:
      "Feedback is expected. Endless revision loops aren’t. We work in clear phases with defined checkpoints so progress never stalls.",
  },
  {
    question: "How long does it usually take to see real results?",
    answer:
      "It depends on the problem, but meaningful traction usually appears within weeks—not months—because we focus on impact, not busywork.",
  },
  {
    question: "How do you price your services?",
    answer:
      "We don’t do one-size-fits-all pricing. Scope, complexity, and risk determine cost. If you want the cheapest option, we’re not it.",
  },
  {
    question: "What happens if priorities change mid-project?",
    answer:
      "They usually do. We adapt, but changes are handled deliberately—not impulsively—so the project doesn’t lose direction or quality.",
  },
  {
    question: "Will our internal team be able to maintain the work?",
    answer:
      "Yes. We build systems, not dependencies. Everything is documented and structured so your team can take over without chaos.",
  },
]

export {
  heroSection,
  services,
  aboutUs,
  whyChoose,
  testimonials,
  faqs,
}
